import React from "react";
import "./active.css";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import FeaturesOnServices from "./FeaturesOnServices";
import OurApproach from "./OurApproach";
import Technologies from "./Technologies";
import CallToAction from "./CallToAction";

const Active = () => {
  return (
    <>
      <Particles title="Active" />
      <HeroSection />
      <FeaturesOnServices />
      <OurApproach />
      <Technologies />
      <CallToAction />
    </>
  );
};

export default Active;
